import { render } from "./ks-group-cust-view.vue?vue&type=template&id=79241d71"
import script from "./ks-group-cust-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ks-group-cust-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/ks-group-cust-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79241d71"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79241d71', __exports__)) {
    api.reload('79241d71', __exports__)
  }
  
  module.hot.accept("./ks-group-cust-view.vue?vue&type=template&id=79241d71", () => {
    api.rerender('79241d71', render)
  })

}


export default __exports__